export const DARK_SLATE03 = "#152561";

export const MODAL_BACKDROP = "#3d3d3d4d";

// NOTE: KEY VALUES NOT TO BE MODIFIED

export const COLORS = {
  PRIMARY: "#5361E9",
  NEUTRAL_95: "#F2EFEC",
  SELECTION_01: "#D2D6FF",
  SANDSTONE: "#FFFAED",
  SANDSTONE_03: "#FCFAF8",
  SANDSTONE_04: "#F9F5F1",
  BRASS: "#F3E7D1",
  BRASS_02: "#F9F2E7",
  DARK_BRASS: "#EBD6AE",
  SAPPHIRE: "#020F3E",
  SAPPHIRE_02: "#152561",
  SAPPHIRE_03: "#091F6B",
  SAPPHIRE_04: "#AFB6F6",
  SAPPHIRE_05: "#E1E4FA",
  SAPPHIRE_LIGHT: "#D2D6FA",
  MOGUL: "#102D1E",
  MOGUL_02: "#2B5740",
  COMMANDER: "#F5B9B9",
  COMMANDER_02: "#FADBDB",
  SCHOLAR: "#B1E2D0",
  SCHOLAR_02: "#D2EEE4",
  CITRINE: "#FFC28A",
  CITRINE_DARK: "#EA8930",
  COLORS: "#F09059",
  SELECTION_02: "#EEEFFF",
  BLACK: "#000000",
  BLACK_90: "#232228E6",
  BLACK_70: "#232228B3",
  NEUTRAL_BLACK: "#232228",
  DARK_SLATE_90: "#64748b90",
  DARK_SLATE01: "#393f41",
  DARKS_LATE02: "#878C91",
  DARK_SLATE03: "#AAB1B7",
  DARK_SLATE04: "#878C90",
  DARK_SLATE05: "#53585B",
  WHITE: "#FFFFFF",
  WHITE_02: "#FFFEFA",
  WHITE_90: "#FFFFFFE6",
  WHITE_70: "#FFFFFFB3",
  SLATE_LIGHT: "#F7F9FA",
  SLATE_STROKE: "#E5E5E5",
  SLATESTROKE_LIGHT: "#E5E5E580",
  PURPLE: "#DDDFFA",
  YELLOW: "#FFFBDB",
  GREEN: "#E5FFF1",
  SUCCESS_LIGHT: "#D3FFE0",
  SUCCESS_MID: "#42BE65",
  SUCCESS_DARK: "#12732D",
  WARNING_LIGHT: "#FFF8E0",
  WARNING_MID: "#F1C21B",
  WARNING_DARK: "#CEA511",
  ERROR_LIGHT: "#FFD8DA",
  ERRORLIGHT_02: "#FAEAEA",
  ERROR_MID: "#FA4D56",
  ERROR_MID_01: "#E85555",
  ERROR_DARK: "#96141B",
  SLATE: "#E5E5E5",
  SLATE_01: "#282828",
  SLATE_02: "#4A4A4A",
  SLATE_03: "#A8A8A8",
  SLATE_04: "#DFDFDF",
  SLATE_05: "#F7F7F7",
  DASH: "#6A82E3",
  DASH_LIGHT: "#EBEEFB",
  DASH_DARK: "#4462DC",
  DASH_LIGHTEST: "#F5F7FF",
  TRANSPARENT: "transparent",
  LINKEDIN_BLUE: "#2967B2",
  LIGHT_BLUE: "#f8ffff",
  BROWN: "#753723",
  GREY_00: "#FFFFFF",
  GREY_01: "#F8F8FC",
  GREY_02: "#E9E9F2",
  GREY_03: "#7A7D94",
  GREY_04: "#3A3D50",
  PURPLE_00: "#F1F0FF",
  PURPLE_01: "#D7D6ED",
  PURPLE_02: "#8984FF",
  PURPLE_03: "#6059FF",
  PURPLE_04: "#2E27C3",
  GREEN_00: "#D2FCE4",
  GREEN_01: "#85EEB2",
  GREEN_02: "#19CE67",
  GREEN_03: "#10A750",
  YELLOW_00: "#FFF5D3",
  YELLOW_01: "#FFDF70",
  YELLOW_02: "#FFCF26",
  YELLOW_03: "#E2B102",
  YELLOW_04: "#877102",
};
